import { Component, Input, ViewParent } from 'angular-ts-decorators';

/**
 * Component that adds save button that communicates with <sw-editable-field>
 *
 * @example
 * <sw-editable-save sw-value="$ctrl.model"></sw-editable-save>
 */
@Component({
  selector: 'swEditableSave',
  template: require('./sw-editable-save.html').default,
})
export class SwEditableSaveComponent {
  /**
   * Turns button into disabled if true
   */
  @Input() swDisabled: boolean;

  /**
   * Supposed to have the same value as the input component it works with.
   * Sends the value to swEditableField when clicked.
   */
  @Input() swValue: any;

  /**
   * Controller of the wrapping swEditableField component
   */
  @ViewParent('^^?') swEditableField: ng.INgModelController;

  constructor() {
    'ngInject';
  }
}
